import { LiaRupeeSignSolid } from "react-icons/lia";
import {
  HeadingTitle,
  SubHeadingTitle,
  Button,
  Image,
  Loader,
} from "../../../../components/shared/index";

import { getImageUrl } from "../../../../lib/get-image";
import styles from "./checkoutpayment.module.css";
const CheckoutOrderSummary = ({
  cartItems,
  orderSummary,
  handlePlaceOrder,
  isCartPending,
  isOrderPlacePending,
   selectedPayment  ,
     selectedCount,
}) => {
  return (
    <div className={styles.orderSummarySection}>
      <HeadingTitle text="Order Summary" style={styles.summaryHeading} />
      {isCartPending ? (
        <Loader title="Loading orders..." />
      ) : (
        <div className={styles.cartItems}>
          {(cartItems || []).map((item) => (
            <div key={item.id} className={styles.cartItem}>
              <Image
                src={getImageUrl(item?.product?.thumb_image)}
                alt={item?.product?.name}
                className={styles.itemImage}
              />
              <div className={styles.iteminfo}>
                <SubHeadingTitle
                  subTitle={item?.product?.name}
                  style={styles.itemName}
                />
                <div className={styles.rowLine}>
                  {/* <SubHeadingTitle
                    subTitle={`Size: ${item?.size || "-"}`}
                    style={styles.itemSize}
                  /> */}
                 {(() => {
  const price = Number(item?.product?.price || 0);

  const offer =
    item?.product?.offer_price !== null &&
    item?.product?.offer_price !== undefined &&
    item?.product?.offer_price !== ""
      ? Number(item?.product?.offer_price)
      : null;

  const hasOffer = offer !== null && offer < price;

  const finalPrice = hasOffer ? offer : price;

  const discountPercent = hasOffer
    ? Math.round(((price - offer) / price) * 100)
    : 0;

  return (
    <div className={styles.checkoutPriceBox}>
      <div className={styles.checkoutFinalPrice}>
        <LiaRupeeSignSolid />
        {finalPrice}
      </div>

      {hasOffer && (
        <div className={styles.checkoutOfferRow}>
          <span className={styles.checkoutOriginalPrice}>
            ₹{price}
          </span>

          <span className={styles.checkoutDiscount}>
            {discountPercent}% OFF
          </span>
        </div>
      )}
    </div>
  );
})()}
                  <SubHeadingTitle
                    subTitle={`Qty: ${item?.quantity || 1}`}
                    style={styles.itemSize}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )} 
      <div className={styles.summaryDetails}>
     <div className={styles.summaryRow}>
  <div>
    <SubHeadingTitle
      subTitle="Subtotal"
      style={styles.summaryLabel}
    />

    <div
      style={{
        fontSize: "12px",
        opacity: 0.7,
        marginTop: "2px",
      }}
    >
      ({selectedCount} item{selectedCount !== 1 ? "s" : ""})
    </div>
  </div>

  <SubHeadingTitle
    subTitle={`₹${orderSummary?.subtotal || 0}`}
    style={styles.summaryValue}
  />
</div>
        <div className={styles.summaryRow}>
          <SubHeadingTitle subTitle="Shipping" style={styles.summaryLabel} />
          <SubHeadingTitle
            subTitle={
              orderSummary?.shipping === 0
                ? "Free"
                : `₹${orderSummary?.shipping || 0}`
            }
            style={styles.summaryValue}
          />
        </div>
        <div className={styles.summaryRow}>
          <SubHeadingTitle subTitle="Tax" style={styles.summaryLabel} />
          <SubHeadingTitle
            subTitle={`₹${orderSummary?.tax || 0}`}
            style={styles.summaryValue}
          />
        </div>
        <div className={`${styles.summaryRow} ${styles.totalRow}`}>
          <SubHeadingTitle subTitle="Total" style={styles.totalLabel} />
          <SubHeadingTitle
            subTitle={`₹${orderSummary?.total || 0}`}
            style={styles.totalValue}
          />
        </div>
      </div>
   <Button
  type="button"
  title={
    isOrderPlacePending ? (
      <>
        <span className={styles.spinner}></span>
        Processing...
      </>
    ) : selectedPayment === "cod" ? (
      "Place an Order"
    ) : (
      "Pay Now"
    )
  }
  style={styles.payButton}
  onHandler={handlePlaceOrder}
  disabled={isOrderPlacePending}
/>
    </div>
  );
};
export default CheckoutOrderSummary;